//忘刷卡申请流程
import React from 'react'
import { connect } from 'react-redux'
import { doForgetSwipeCardApplyFlow } from '../reducers/actions'
import { doOneDispatch, doDispatchs, copyListValuesById, nullDate, TDate } from '../public/utility'
const doPrepare = (dispatch, props) => {
    const handlerConfirm = () => {
        const { onSave, onClose, id, action, confirmMsg } = props
        const changedValues基本信息 = {}
        Tyan.pubForm.showConfirm(confirmMsg || '确定执行？',
            () =>
                doOneDispatch(dispatch, [doForgetSwipeCardApplyFlow, { id, action, changedValues基本信息 }])
                    .then(() => {
                        Ext.toast('执行成功')
                        onClose && onClose()
                        onSave && onSave()
                    })
                    .catch(errorMessage => Tyan.pubForm.showError(errorMessage))
        )
    }
    const { onSave, onClose, action, } = props
    const events = []
    switch (action) {
        case '初审中.提交':
        case '审核中.提交':
        case '复审中.提交':
        case '批准中.批准':
        case '初审中.退回申请':
        case '审核中.退回申请':
        case '复审中.退回申请':
        case '批准中.退回申请':
        case '已完成.退回申请':
            break
        default:
            handlerConfirm()
            return
    }
    return events
}
class ForgetSwipeCardApplyAction extends React.Component {
    state = {
        errorMessage: null,
        changedValues基本信息: {},
        initValues基本信息: {}
    }

    componentDidMount = () => {
        this.handlerInitValue(this.props.id)
    }

    handlerInitValue = (id) => {
        const { onSave, onClose, dispatch, action, objGaugeInfo, gaugeType, sampleDispose, businessType, applicationType, haveCalibrationReport, events } = this.props
        if (events.length > 0) {
            doDispatchs(dispatch, events)
                .then(ret => {
                    this.setState({ ...ret })
                })
                .catch(errorMessage => Tyan.pubForm.showError(errorMessage, onClose))
        }
    }

    handlerSave = () => {
        const { onSave, onClose, dispatch, id, action } = this.props
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        doOneDispatch(dispatch, { fn: doForgetSwipeCardApplyFlow, data: { id, action, changedValues基本信息 } })
            .then(() => {
                Ext.toast('执行成功')
                onClose && onClose()
                onSave && onSave()
            })
            .catch((err) => Tyan.pubForm.showError(err))
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    canSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        const { onClose } = this.props
        switch (this.props.action) {
            case '初审中.退回申请':
            case '审核中.退回申请':
            case '复审中.退回申请':
            case '批准中.退回申请':
            case '已完成.退回申请':
                return values.退回原因
        }
        return true
    }

    fieldset基本信息 = () => {
        switch (this.props.action) {
            case '初审中.提交':
            case '审核中.提交':
            case '复审中.提交':
            case '批准中.批准':
                return [
                    { _text: '审核意见', maxRows: 3 },
                ]
            case '初审中.退回申请':
            case '审核中.退回申请':
            case '复审中.退回申请':
            case '批准中.退回申请':
            case '已完成.退回申请':
                return [
                    { _text: '退回原因', required: true, maxRows: 3 },
                ]
        }
        return []
    }
    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { initValues基本信息, changedValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const canSave = this.canSave()
        const { id } = initValues基本信息
        return <Body data={this} maxWidth="800"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerSave, disabled: !canSave },
                    { _button: '取消', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}
const ConnectedForgetSwipeCardApplyAction = connect()(ForgetSwipeCardApplyAction)
const doForgetSwipeCardApplyAction = (dispatch, title, props) => {
    const events = doPrepare(dispatch, props)
    events && Tyan.pubForm.showDialog(title, ConnectedForgetSwipeCardApplyAction, { ...props, events })
}
export { doForgetSwipeCardApplyAction }